namespace $ { $mol_style_attach( "shm/hitalama/map/widget/float/form/custom/custom.view.css",
 "[shm_hitalama_map_widget_float_form_custom_form] [mol_form_foot] {\n\tflex-direction: column;\n\talign-items: stretch;\n}\n"
) }